import { render, staticRenderFns } from "./AddIzinPenggalian.vue?vue&type=template&id=ce88650a&lang=pug&"
import script from "./AddIzinPenggalian.vue?vue&type=script&lang=js&"
export * from "./AddIzinPenggalian.vue?vue&type=script&lang=js&"
import style0 from "./AddIzinPenggalian.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports